
import { defineComponent } from "vue";

export default defineComponent({
  name: "BoxComp",
  data() {
    return {
      styles: {
        backgroundColor: "#FaF0CA",
      },
    };
  },
});
